import { makeStyles } from '@mui/styles'

export default makeStyles((theme) => ({
    root: {
        textAlign: 'center'
    },
    title: {
        paddingTop: 20,
        paddingRight: 20
    },
    operatorImage: {
        width: 100,
        height: 100,
        marginTop: 85,
        marginBottom: 25
    },
}))
